import RestStore from "@shared/svelte/Stores/RestStore";

export default function SignupUserStore(initial: any) {
  const store = RestStore(initial, "/api/onboarding/account", "user");
  return store;
}
